import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center gap-10" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 text-muted fs-7"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = ["srcdoc"]
const _hoisted_10 = { style: {"flex":"auto"} }

import { ref, computed } from "vue";
import moment from "moment";
import { TenantOptions } from "@/core/types/TenantTypes";
import { getUserTenantId } from "@/core/types/TenantTypes";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import "jodit/build/jodit.min.css";
import { JoditEditor } from "jodit-vue";
import notification from "@/core/plugins/notification";
import TopicService from "../../services/TopicService";
import type { FormRules, FormInstance } from "element-plus";
import { getAccountRolesOptions } from "@/core/types/AccountInfos";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAndEditBatch',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {

const formRef = ref<FormInstance>();

const ModalRef = ref(false);
const isLoading = ref(false);
const languageList = ref<any>(["en-us", "zh-cn"]);
const defaultEmailTemplateId = ref(10003);
const isEdit = ref(false);
const isDuplicate = ref(false);
// 用户选择的本地时间（仅前端展示用），提交时转成 UTC 放进 formData.effectiveFrom
const scheduleLocalTime = ref<string>("");

// 本地时间 -> UTC，发上去的就是这个
const effectiveFromUtc = computed(() =>
  scheduleLocalTime.value
    ? moment(scheduleLocalTime.value).utc().format("YYYY-MM-DDTHH:mm:ss")
    : null
);

// 只能选今天及以后（禁用过去的日期）
const disabledPastDate = (date: Date) =>
  date.getTime() < Date.now() - 24 * 60 * 60 * 1000;

const formData = ref<any>({
  title: "",
  noDuplicate: true,
  tenantIds: [getUserTenantId()],
  roles: [],
  emailTemplateIds: { [getUserTenantId()]: defaultEmailTemplateId.value },
  emailList: "",
  scheduleSend: false,
  effectiveFrom: null,
  contents: {
    [getUserTenantId()]: {
      "en-us": {
        title: "",
        content: "",
      },
      "zh-cn": {
        title: "",
        content: "",
      },
    },
  },
});

const onTenantClicked = (tenant) => {
  if (formData.value.tenantIds.includes(tenant)) {
    // 新选中的 tenant：把第一个默认 tenant 的内容搬过去（深拷贝，避免共用引用）
    const sourceTenant = getUserTenantId();
    formData.value.emailTemplateIds[tenant] =
      formData.value.emailTemplateIds[sourceTenant] ??
      defaultEmailTemplateId.value;
    const sourceContents = formData.value.contents[sourceTenant] ?? {
      "en-us": { title: "", content: "" },
      "zh-cn": { title: "", content: "" },
    };
    formData.value.contents[tenant] = JSON.parse(
      JSON.stringify(sourceContents)
    );
  } else {
    delete formData.value.emailTemplateIds[tenant];
    delete formData.value.contents[tenant];
  }
};

const prefillEditData = (data) => {
  formData.value.title = data[0].title;
  formData.value.batchId = getBatchObj(data[0].additionalInformation).batchId;
  formData.value.emailList = getBatchObj(
    data[0].additionalInformation
  ).emailList;
  formData.value.noDuplicate = getBatchObj(
    data[0].additionalInformation
  ).noDuplicate;
  formData.value.tenantIds = getBatchObj(
    data[0].additionalInformation
  ).tenantIds.map((x) => parseInt(x));
  for (var i = 0; i < data.length; i++) {
    var tenantId = data[i].tenantId;
    var emailTemplateId = getBatchObj(
      data[i].additionalInformation
    ).emailTemplateId;
    formData.value.emailTemplateIds[tenantId] = parseInt(emailTemplateId);
    formData.value.contents[tenantId] = data[i].contents;
  }
  formData.value.roles = getBatchObj(data[0].additionalInformation).roles;
};

// 回填 schedule：兼容顶层字段或 additionalInformation 里的 scheduleSend/effectiveFrom
const prefillSchedule = (src: any) => {
  const ai = getBatchObj(src.additionalInformation);
  const effectiveFrom = src.effectiveFrom ?? ai.effectiveFrom ?? null;
  const scheduleSend = src.scheduleSend ?? ai.scheduleSend ?? !!effectiveFrom;
  formData.value.scheduleSend = Boolean(scheduleSend) && Boolean(effectiveFrom);
  // 存的是 UTC，转回本地填进选择器
  scheduleLocalTime.value = effectiveFrom
    ? moment.utc(effectiveFrom).local().format("YYYY-MM-DDTHH:mm:ss")
    : "";
};

const getDataByBatchId = async (item) => {
  isLoading.value = true;
  try {
    var batchId = getBatchObj(item.additionalInformation).batchId;
    var tenantIds = getBatchObj(item.additionalInformation).tenantIds;
    const res = await TopicService.getEmailBatchById(batchId, tenantIds);
    prefillEditData(res);
    prefillSchedule(item);
    console.log(formData.value);
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const onLanguageClicked = (tenant, language) => {
  if (formData.value.contents[tenant][language]) {
    delete formData.value.contents[tenant][language];
    return;
  }
  formData.value.contents[tenant][language] = {
    title: "",
    content: "",
  };
};

const refreshHtml = (item) => {
  return item.content;
};



const submit = async () => {
  if (!formRef.value) return;

  let isValid = false;
  await formRef.value.validate(async (valid) => {
    isValid = valid;
  });
  if (!isValid) return;
  // 开启 schedule 才传 UTC 时间，否则置空（create / update 都生效）
  formData.value.effectiveFrom = formData.value.scheduleSend
    ? effectiveFromUtc.value
    : null;
  console.log(formData.value);
  if (isEdit.value) {
    await updateBatch();
  } else {
    await createBatch();
  }
};

const createBatch = async () => {
  isLoading.value = true;
  try {
    // duplicate 预填时 emailList 已是数组，仅字符串才需要 split
    if (
      typeof formData.value.emailList === "string" &&
      formData.value.emailList
    ) {
      formData.value.emailList = formData.value.emailList
        .split(",")
        .map((x) => x.trim());
    }
    await TopicService.createEmailBatchV2(formData.value);
    notification.success();
    emits("refresh");
    hide();
    reset();
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const updateBatch = async () => {
  isLoading.value = true;
  try {
    await TopicService.updateEmailBatchV2(formData.value);
    notification.success();
    emits("refresh");
    hide();
    reset();
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const show = async (item?: any) => {
  ModalRef.value = true;
  isDuplicate.value = false;
  if (item) {
    isEdit.value = true;
    await getDataByBatchId(item);
  } else {
    isEdit.value = false;
    reset();
  }
  console.log(formData.value);
};

// 复制：预填该 topic 的数据（含 schedule），但保持创建模式（提交时建新的）
const duplicate = async (item: any) => {
  ModalRef.value = true;
  isEdit.value = false;
  isDuplicate.value = true;
  await getDataByBatchId(item);
  // 清掉旧 batchId，让后端生成新的
  delete formData.value.batchId;
  console.log(formData.value);
};

const reset = () => {
  scheduleLocalTime.value = "";
  formData.value = {
    title: "",
    noDuplicate: true,
    tenantIds: [getUserTenantId()],
    emailTemplateIds: { [getUserTenantId()]: defaultEmailTemplateId.value },
    scheduleSend: false,
    effectiveFrom: null,
    contents: {
      [getUserTenantId()]: {
        "en-us": {
          title: "",
          content: "",
        },
        "zh-cn": {
          title: "",
          content: "",
        },
      },
    },
  };
};

const formRules = {
  title: [{ required: true, message: "Please input title", trigger: "blur" }],
  emailTemplateIds: [
    {
      required: true,
      message: "Please select email template",
      trigger: "blur",
    },
  ],
  contents: [
    {
      validator: (rule: any, value: any, callback: any) => {
        let error = "";
        Object.keys(value).forEach((tenant) => {
          Object.keys(value[tenant]).forEach((lang) => {
            if (!value[tenant][lang].title || !value[tenant][lang].content) {
              error = "Each content need title and content";
            }
          });
        });
        if (error) {
          callback(new Error(error));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
};

const getBatchObj = (info: string) => {
  try {
    if (!info) return {};
    return JSON.parse(info);
  } catch (e) {
    return {};
  }
};

const hide = () => {
  ModalRef.value = false;
};

__expose({
  show,
  duplicate,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: ModalRef.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ModalRef).value = $event)),
    direction: "rtl",
    size: "90%",
    title: 
      isEdit.value ? 'Edit Batch' : isDuplicate.value ? 'Duplicate Batch' : 'Create Batch'
    
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          "label-position": "top",
          model: formData.value,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_form_item, {
                label: "Title",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
                    class: "w-250px",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Email List" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.emailList,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.emailList) = $event)),
                    autosize: { minRows: 2, maxRows: 4 },
                    type: "textarea",
                    disabled: isLoading.value,
                    class: "w-450px"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.accessRoles'),
                prop: "roles"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: formData.value.roles,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.roles) = $event)),
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAccountRolesOptions), (role, index) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: index,
                          label: role.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(role.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, { label: "Schedule Send" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_switch, {
                        modelValue: formData.value.scheduleSend,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.scheduleSend) = $event)),
                        disabled: isLoading.value
                      }, null, 8, ["modelValue", "disabled"]),
                      (formData.value.scheduleSend)
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 0,
                            modelValue: scheduleLocalTime.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((scheduleLocalTime).value = $event)),
                            type: "datetime",
                            placeholder: "Select schedule time",
                            "value-format": "YYYY-MM-DDTHH:mm:ss",
                            "disabled-date": disabledPastDate,
                            class: "ms-3"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    (formData.value.scheduleSend && scheduleLocalTime.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("div", null, "Local time: " + _toDisplayString(scheduleLocalTime.value), 1),
                          _createElementVNode("div", null, "UTC time (effectiveFrom): " + _toDisplayString(effectiveFromUtc.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (formData.value.tenantIds.length > 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "No Duplicate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: formData.value.noDuplicate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.noDuplicate) = $event)),
                        disabled: isLoading.value
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_form_item, { label: "Select Tenants" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: formData.value.tenantIds,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.tenantIds) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TenantOptions), (tenant) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: tenant.value,
                          label: tenant.value,
                          disabled: tenant.value === _unref(getUserTenantId)(),
                          onChange: ($event: any) => (onTenantClicked(tenant.value))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tenant.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "disabled", "onChange"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tabs, {
                type: "border-card",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.tenantIds, (tenant, tenantIndex) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      label: _unref(TenantOptions).find((x) => x.value === tenant)?.label,
                      key: tenantIndex
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "Email Template ID" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.value.emailTemplateIds[tenant],
                              "onUpdate:modelValue": ($event: any) => ((formData.value.emailTemplateIds[tenant]) = $event),
                              disabled: isLoading.value,
                              class: "w-250px"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_4,
                        _createVNode(_component_el_form_item, { label: "Select Languages" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: languageList.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((languageList).value = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (content, langIndex) => {
                                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                                    key: langIndex,
                                    label: content.code,
                                    value: content.code,
                                    disabled: isLoading.value || content.code === 'en-us',
                                    onChange: ($event: any) => (onLanguageClicked(tenant, content.code))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(content.code), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value", "disabled", "onChange"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_tabs, { type: "card" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.contents[tenant], (item, contentIndex) => {
                              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                label: contentIndex,
                                key: contentIndex
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(_component_el_form_item, {
                                        label: "Title",
                                        prop: `contents.${tenant}.${contentIndex}.title`,
                                        rules: {
                            required: true,
                            message: 'Please input title',
                            trigger: 'blur',
                          }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: item.title,
                                            "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                                            disabled: isLoading.value
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop"]),
                                      _createVNode(_component_el_form_item, {
                                        label: "Content",
                                        prop: `contents.${tenant}.${contentIndex}.content`,
                                        rules: {
                            required: true,
                            message: 'Please input content',
                            trigger: 'blur',
                          }
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_unref(JoditEditor), {
                                              modelValue: item.content,
                                              "onUpdate:modelValue": ($event: any) => ((item.content) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop"])
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("iframe", {
                                        srcdoc: refreshHtml(item),
                                        width: "100%",
                                        height: "100%"
                                      }, null, 8, _hoisted_9)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_button, {
          onClick: hide,
          plain: "",
          type: "danger",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          plain: "",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(isEdit.value ? _ctx.$t("action.update") : _ctx.$t("action.create")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})